'use client';

import { PublicClientApplication } from '@azure/msal-browser';
import { AuthenticatedTemplate, MsalProvider } from '@azure/msal-react';
import MsalAuth from '@components/MsalAuthentication';
import { acquireToken, getTokenLocalStorage, setTokenLocalStorage } from '@config/authentication';
import { getMsalInstance } from '@config/authentication/msalConfig';
import { useEffect, useState } from 'react';

export interface IMsalAuthProviderProps {
  children?: React.ReactNode;
}

export const MsalAuthProvider = ({ children }: IMsalAuthProviderProps) => {
  const [emptyToken, setEmptyToken] = useState(true);
  const [token, setToken] = useState<string | null>();
  const [msalInstance, setMsalInstance] = useState<PublicClientApplication>();

  useEffect(() => {
    const msalInstance = getMsalInstance();
    setMsalInstance(msalInstance);
    const accounts = msalInstance?.getAllAccounts();
    if (accounts?.length > 0) {
      msalInstance?.setActiveAccount(accounts?.[0] ?? null);
    }
    msalInstance
      .handleRedirectPromise()
      .then(async (tokenResponse) => {
        if (tokenResponse === null || tokenResponse === undefined) {
          await acquireToken(msalInstance);
        } else {
          setTokenLocalStorage(tokenResponse?.accessToken);
        }
      })
      .catch((error) => {
        console.error(error);
      });

    setToken(getTokenLocalStorage());
  }, []);

  useEffect(() => {
    if (!token && msalInstance) {
      acquireToken(msalInstance).then(() => {
        setEmptyToken(false);
      });
    } else {
      setEmptyToken(false);
    }
  }, [token]);

  if (emptyToken) return null;

  return (
    <MsalProvider instance={msalInstance as PublicClientApplication}>
      <MsalAuth>
        <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
      </MsalAuth>
    </MsalProvider>
  );
};
